import { PostMessageReply, PostMessage } from '../Shared/PostMessage';
import { MeetingInformation } from './ComponentMeetingInformationProviderDefinitions';

export const GetMeetingInformationMessageType = 'ComponentMeetingInformationProvider_GetMeetingInformation';
export const SetMeetingInformationMessageType = 'ComponentMeetingInformationProvider_SetMeetingInformation';

export interface GetMeetingInformationMessage extends PostMessage<typeof GetMeetingInformationMessageType> {}

export interface GetMeetingInformationReplyMessage extends PostMessageReply {
  payload: MeetingInformation;
}

export interface SetMeetingInformationMessage extends PostMessage<typeof SetMeetingInformationMessageType> {
  payload: { information: MeetingInformation };
}
